import {GET_PPRODUCTS} from "../actions/types";

const initialState = {
    products: false
};

const productReducer = (state = initialState, action) => {
    switch (action.type) {
        case GET_PPRODUCTS:
            return {...state, products: action.payload};
        default:
            return state;
    }
};

export default productReducer;


